// export to clarify which component is imported between anchor and window
import Dropdown from './DropdownAnchor';
export default Dropdown;
